import { Helpers } from './helpers.js';
import { Resources } from './resources.js';
import { Prototype } from './prototype.js';
import { AdminPrototype } from './configs/src/admin-prototype.js';
import { AdminDefault } from './configs/src/admin-default.js';
import { AdminMini } from './configs/src/admin-mini.js';
import { AdminEmail } from './configs/src/admin-email.js';
import { AdminEmailLayout } from './configs/src/admin-email-layout.js';
import { AdminLocal } from './configs/src/admin-local.js';
import { AdminPoll } from './configs/src/admin-poll.js';
import { AdminEvent } from './configs/src/admin-event.js';
import { AdminCards } from './configs/src/admin-cards.js';
import { PublicPrototype } from './configs/src/public-prototype.js';
import { PublicConfig } from './configs/src/public-config.js';
import { PublicValidators } from './public-validators.js';


if (!BEditor.Config)
{
  BEditor.Config = new Config();
  new PublicValidators();
}

BEditor.themeResourcesPostfix = '';


export default function Config ()
{
  const pThis = this;

  pThis.Ready = BEditor.eventHandlers.createHandlers(pThis, { id: 'Ready', type: BEditor.eventHandlers.Type.Long });

  pThis.getThemeStyles = getThemeStyles;
  pThis.refreshThemeResources = refreshThemeResources;
  pThis.getSpriteUrl = getSpriteUrl;
  pThis.getSpriteByName = getSpriteByName;

  const pConfig =
  {
    pThis,

    get resources() { return resources; },
    get themeStyles() { return themeStyles; }

  };


  const helpers = new Helpers(pConfig);
  const resources = new Resources(pConfig);


  let EditorToolbarPrototype,
      themeStyles = {};




  function init ()
  {
    if (BEditor.AdminPanel)
    {
      BEditor.AdminPanel.VisualStylesChanged.addHandler(refreshThemeResources);
      BEditor.AdminPanel.ThemeResourcesLoaded.addHandler(create);
    }

    BEditor.services.getThemeStyles(create, onThemeStylesLoadFailed);
  }


  function create (data)
  {
    const styles =
          [
            'dividerStyles',
            'fontStyles',
            'formatStyles',
            'linkStyles'
          ];

    for (let i = 0; i < styles.length; i++)
    {
      if (themeStyles[styles[i]])
      {
        themeStyles[styles[i]].splice(0, themeStyles[styles[i]].length);
      }
      else
      {
        themeStyles[styles[i]] = [];
      }

      if (data[styles[i]])
      {
        for (let n = 0; n < data[styles[i]].length; n++)
        {
          themeStyles[styles[i]][n] = data[styles[i]][n];
        }
      }
    }

    themeStyles['colors'] = data.SharedResources.colors;

    EditorToolbarPrototype = new Prototype(pConfig);
    helpers.editorToolbarButtonsConfigParser(EditorToolbarPrototype);

    if (BEditor.environment.internalPageType.isAdminPage) //TODO:DIME
    {
      createEditorAdminConfig();
    }
    else
    {
      createEditorPublicConfig();
    }

    pThis.Ready.fireHandlers();
  }


  function onThemeStylesLoadFailed ()
  {

  }


  function getThemeStyles ()
  {
    return themeStyles;
  }


  function refreshThemeResources ()
  {
    BEditor.themeResourcesPostfix = (new Date()).getTime();
    BEditor.services.getThemeStyles(create, onThemeStylesLoadFailed);
    BEditor.clearRealBackgroundForEvents();
  }


  function getSpriteUrl (area)
  {
    area = area || 'iconsSmall';

    return resources.sprites[area].url;
  }


  function getSpriteByName (area, name)
  {
    area = area || 'iconsSmall';
    name = name || 'AdditionalSpace';

    return (resources.spritesHash[area + '_' + name] ? resources.spritesHash[area + '_' + name] : resources.spritesHash[area + '_AdditionalSpace']);
  }


  function createEditorAdminConfig ()
  {
    window.EditorToolbarPrototypeConfig = new AdminPrototype(pConfig);
    window.EditorToolbar = helpers.editorToolbarConfigRenderer(EditorToolbarPrototype, EditorToolbarPrototypeConfig);

    window.EditorToolbarDefaultConfig = new AdminDefault(pConfig);
    helpers.editorToolbarConfigCopier(EditorToolbarPrototypeConfig, EditorToolbarDefaultConfig);

    window.EditorToolbarMiniConfig = new AdminMini(pConfig);
    helpers.editorToolbarConfigCopier(EditorToolbarPrototypeConfig, EditorToolbarMiniConfig);

    window.EditorToolbarComposeEmailConfig = new AdminEmail(pConfig);
    helpers.editorToolbarConfigCopier(EditorToolbarPrototypeConfig, EditorToolbarComposeEmailConfig);

    window.EditorToolbarLocalConfig = new AdminLocal(pConfig);
    window.EditorLocalToolbar = helpers.editorToolbarConfigRenderer(EditorToolbarPrototype, EditorToolbarLocalConfig);

    window.EditorToolbarPollDescriptionLocalConfig = new AdminPoll(pConfig);
    window.EditorPollDescriptionLocalToolbar = helpers.editorToolbarConfigRenderer(EditorToolbarPrototype, EditorToolbarPollDescriptionLocalConfig);

    window.EditorToolbarEventDescriptionLocalConfig = new AdminEvent(pConfig);
    window.EditorEventDescriptionLocalToolbar = helpers.editorToolbarConfigRenderer(EditorToolbarPrototype, EditorToolbarEventDescriptionLocalConfig);

    window.EditorToolbarEmailLayoutLocalConfig = new AdminEmailLayout(pConfig);
    window.EditorEmailLayoutLocalToolbar = helpers.editorToolbarConfigRenderer(EditorToolbarPrototype, EditorToolbarEmailLayoutLocalConfig);

    window.EditorToolbarCardsLocalConfig = new AdminCards(pConfig);
    window.EditorCardsLocalToolbar = helpers.editorToolbarConfigRenderer(EditorToolbarPrototype, EditorToolbarCardsLocalConfig);
  }


  function createEditorPublicConfig ()
  {
    window.EditorToolbarPrototypeConfig = new PublicPrototype(pConfig);
    window.EditorToolbar = helpers.editorToolbarConfigRenderer(EditorToolbarPrototype, EditorToolbarPrototypeConfig);

    window.EditorToolbarPublicConfig = new PublicConfig(pConfig);
    helpers.editorToolbarConfigCopier(EditorToolbarPrototypeConfig, EditorToolbarPublicConfig);
  }


  BEditor.domHandlers.addPageParsedHandler(init);
}
